import * as XLSX from 'xlsx';

export const exportToExcel = (tableRef, fileName = 'export.xlsx') => {
    if (tableRef && tableRef?.current) {
        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.table_to_sheet(tableRef.current);
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        XLSX.writeFile(wb, `${fileName}.xlsx`);
    } else {
        return {
            onDownload: null,
        };
    }
};
